import type { Category, Question, AnswerValue } from '../types';

// ── Category colors (shared across components) ─────────────────────

export const CATEGORY_COLORS: Record<Category, string> = {
  'basics': 'bg-pink-400',
  'roleplay': 'bg-purple-400',
  'butt-stuff': 'bg-amber-400',
  'positions': 'bg-teal-400',
  'bdsm': 'bg-red-400',
  'frequency-location': 'bg-sky-400',
  'toys-devices': 'bg-indigo-400',
  'body-preferences': 'bg-green-400',
  'swingers': 'bg-orange-400',
};

// ── Section boundary types & computation ────────────────────────────

export interface SectionInfo {
  category: Category;
  startIndex: number;
  endIndex: number;
  questions: Question[];
}

export function computeSections(
  filteredQuestions: Question[],
  activeCategories: Category[],
): SectionInfo[] {
  return activeCategories.map((cat) => {
    const indices: number[] = [];
    const questions: Question[] = [];

    for (let i = 0; i < filteredQuestions.length; i++) {
      const q = filteredQuestions[i];
      if (q && q.category === cat) {
        indices.push(i);
        questions.push(q);
      }
    }

    return {
      category: cat,
      startIndex: indices.length > 0 ? (indices[0] ?? 0) : 0,
      endIndex: indices.length > 0 ? (indices[indices.length - 1] ?? 0) : 0,
      questions,
    };
  });
}

export function getSectionForIndex(
  sections: SectionInfo[],
  globalIndex: number,
): SectionInfo | undefined {
  return sections.find(
    (s) => globalIndex >= s.startIndex && globalIndex <= s.endIndex,
  );
}

export function getFirstUnansweredInSection(
  section: SectionInfo,
  answers: Record<string, AnswerValue>,
): number {
  for (let i = 0; i < section.questions.length; i++) {
    const q = section.questions[i];
    if (q && !(q.id in answers)) {
      return section.startIndex + i;
    }
  }
  return section.startIndex;
}
